import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
// import 'babel-polyfill'

Vue.use(Vuex);

let state = {
  evaluationResult: '',
  userInfo: {},
  shareImg: '',
  userEvaluationInfo: null
};

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
});
